import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@mui/styles';

import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Link } from '@mui/material';
import packageInfo from '../../../package.json';

const styles = theme => ({
    copyright: {
        color: '#545454'
    },
    policy: {
        '&& a': {
            margin: '0 5px',
            color: theme.palette.accent.main,
            textShadow: `0 0 0.5px ${theme.palette.primary.main}`,
            '&:hover': {
                color: theme.palette.secondary.main,
                textDecoration: 'underline',
                textShadow: '0 0 0',
            }
        }
    },
    version: {
        color: '#545454',
        '&& a': {
            color: theme.palette.accent.main,
            textShadow: `0 0 0.5px ${theme.palette.primary.main}`,
            '&:hover': {
                color: theme.palette.secondary.main,
                textDecoration: 'underline',
                textShadow: '0 0 0',
            }
        }
    }
});

const Footer = props => {
    const year = new Date().getFullYear();
    const { classes, t } = props;
    const version = import.meta.env.VITE_APP_VERSION || `${packageInfo.version}-alpha.local`;

    return (
        <footer className={classNames('footer', props.className)}>
            <div className={classes.copyright}>
                ©
                {year}
                , Exadel, Inc.
                {' '}
                {t('allRightsReserved')}
            </div>
            <div className={classes.policy}>
                <Link
                    target="_blank"
                    href="http://exadel.com/privacy-policy/"
                >
                    {t('privacyPolicy')}
                </Link>
                |
                <Link
                    target="_blank"
                    href="http://exadel.com/terms-conditions/"
                >
                    {t('termsAndConditions')}
                </Link>
            </div>
            <div className={classes.version}>
                {t('version')}
                {' '}
                {version}
                {' '}
                <Link
                    target="_blank"
                    href="mailto:e-eis-support@exadel.com"

                >
                    {t('supportRequest')}
                </Link>
            </div>
        </footer>
    );
};

Footer.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.shape({
        copyright: PropTypes.string,
        policy: PropTypes.string,
        version: PropTypes.string,
    }),
};

export default compose(
    withTranslation(),
    withStyles(styles),
)(Footer);
